import { sortTasksByLexorank } from 'helpers/orderTasksByLexorank'
import { api } from '../api'
import { getTaskListParams } from './utils'

export const tasksApi = api
  .enhanceEndpoints({
    addTagTypes: ['KanbanTaskList', 'Task'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getKanbanTaskList: builder.query({
        keepUnusedDataFor: 5,
        providesTags: (result, error, { slug }) => [
          { type: 'KanbanTaskList', id: slug },
        ],
        query: ({ slug, params }) => {
          const preparedParams = getTaskListParams(params)
          return {
            url: `/project/${slug}/task`,
            params: preparedParams,
          }
        },
        transformErrorResponse: (baseError) => {
          if ('status' in baseError) {
            const status =
              typeof baseError.status === 'number' ? baseError.status : 0
            const message = baseError.data?.message || undefined
            return { status, message }
          }
          return { status: 0 }
        },
        transformResponse: (response) => {
          const tasks = response?.data

          if (tasks.length) {
            return tasks.sort(sortTasksByLexorank)
          }

          return []
        },
      }),
      getTaskDetail: builder.query({
        providesTags: (result, error, { id }) => [{ type: 'Task', id }],
        query: ({ id }) => ({ url: `/task/${id}` }),
        transformResponse: (resp) => resp?.data,
      }),
      upsertResponsibleEstimate: builder.mutation({
        query: ({ id, estimate, description }) => ({
          url: `/task/${id}/responsible-estimate`,
          method: 'PATCH',
          body: { estimate, description },
        }),
        invalidatesTags: (result, error, { id }) => [{ type: 'Task', id }],
      }),
    }),
  })

export const {
  useGetKanbanTaskListQuery,
  useGetTaskDetailQuery,
  useLazyGetTaskDetailQuery,
  useUpsertResponsibleEstimateMutation,
} = tasksApi
